import { asyncLoad } from '@util'

// import('@components/LocalMerchant/Dynamic') 旧版四大动态管理发布页

const AsyncDynamic = asyncLoad(() =>
  import('@components/LocalMerchant/ContentCenter/MyCreation')
)

export default {
  path: 'dynamic',
  component: AsyncDynamic,
  stat: '动态管理/首页'
}
